<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

/* -----------------------------------------------------------------------------
   Mobile sticky Add to Cart - size selection.
   Rewritten 11 September 2026.

   THE BUG THIS FIXES
   Ella renders the product form with selected_or_first_available_variant already
   chosen, so on a men's boardshort XS is pre-selected and #product-add-to-cart is
   enabled from page load. The previous version of this handler fired that button
   on every tap of the mobile sticky bar. A shopper who scrolled past the size
   picker to read the liner and sizing copy, then tapped the sticky "ADD TO CART",
   had XS added silently - Ella's mobile size sheet never opened. XS is our
   smallest men's size (31-33" waist), so this also generated avoidable returns.

   THE FIX
   The shortcut only applies once the shopper has deliberately engaged with the
   Size control. Until then the tap is left alone and Ella's native size sheet
   opens as designed, which is the behaviour the theme ships with.

   WHY BOTH 'change' AND 'click'
   A radio fires 'change' only when its value actually changes. XS is already
   checked on load, so a shopper who genuinely wants XS and taps it fires no
   'change' at all - XS would have been the one size that could never use the
   shortcut. Listening for 'click' as well covers that case.

   Scoped to the Size option only, by the control's name attribute ("Size",
   "Size-mobile", or "options[Size]"), so tapping the single-value Colour swatch
   does not count as choosing a size.
   ----------------------------------------------------------------------------- */
(function () {
  var sizeChosen = false;

  function isSizeControl(node) {
    if (!node || !node.closest) return false;
    var field = node.closest('.product-form__input');
    if (!field) return false;
    var input = field.querySelector('input[name], select[name]');
    if (!input) return false;
    return /^size\b|\[size\]/i.test(input.getAttribute('name') || '');
  }

  function markChosen(event) {
    if (isSizeControl(event.target)) sizeChosen = true;
  }

  document.addEventListener('change', markChosen, true);
  document.addEventListener('click', markChosen, true);

  document.addEventListener('click', function (event) {
    var stickyButton = event.target.closest && event.target.closest('#show-sticky-product');
    if (!stickyButton) return;

    /* No deliberate size choice yet - fall through to Ella's size sheet. */
    if (!sizeChosen) return;

    var productButton = document.getElementById('product-add-to-cart');
    if (!productButton || productButton.disabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    productButton.click();
  }, true);
})();

/* -----------------------------------------------------------------------------
   Removed 9 September 2026: the Father's Day offer module.
   The campaign ended 6 September 2026 and the code was already inert behind a
   date guard, but it still shipped ~3KB and a /collections/fathers-day
   products.json fetch definition to every page. Deleted rather than left to rot.
   ----------------------------------------------------------------------------- */

/* -----------------------------------------------------------------------------
   Match the Crew - keep the bundle in step with the size chosen above it.
   Added 12 September 2026.

   THE BUG THIS FIXES
   Reported by a customer on 12 September: she chose a boys' size 6 and ended up
   with a size 4 in her cart, "no matter what I do".

   The Match the Crew block is Ella's "frequently bought together" bundle. It
   renders its own size swatches for each product in the bundle and defaults
   every one to that product's FIRST variant - boys' 4, men's S. It never reads
   the size chosen in the buy box. ADD BOTH TO CART submits the bundle's own
   selections (product-bundle.js -> onSubmitHandler reads each item's group_id),
   so a shopper who picked a size at the top and then pressed that button was
   silently given a size 4.

   It is an easy trap to fall into: the block sits directly beneath the buy box,
   both items come pre-ticked, and ADD BOTH TO CART is a full-width primary
   button - so it reads as *the* add to cart. The per-item CHOOSE SIZE toggles
   are secondary and easy to miss.

   THE FIX
   When the buy box variant changes, tick the matching swatch on the bundle card
   for the SAME product, then let Ella's own change handler take over - it
   already recalculates group_id, the price, the stock note and the bundle
   total. Reusing the theme's machinery rather than reimplementing it keeps this
   small and keeps the bundle's own behaviour intact.

   The sync only fires when the buy box variant actually changes, so a size
   the shopper sets on the bundle card itself is respected and not clobbered by
   the next unrelated click.

   The other product's card is deliberately left alone here. That is a different
   garment for a different person - see the block below, which now requires the
   shopper to choose its size rather than guessing one for them.
   ----------------------------------------------------------------------------- */
(function () {
  var SYNC_DELAY = 160;
  var timer = null;
  var lastPushed = null;

  function syncBundleToBuyBox() {
    try {
      var bundle = document.querySelector('product-bundle');
      if (!bundle || !window.productVariants) return;

      var addButton = document.getElementById('product-add-to-cart');
      var mainForm = addButton && addButton.closest('form');
      if (!mainForm) return;

      var productIdInput = mainForm.querySelector('[name="product-id"]');
      var productId = productIdInput && productIdInput.value;
      if (!productId) return;

      var idInput = mainForm.querySelector('[name="id"]');
      var variantId = idInput && parseInt(idInput.value, 10);
      if (!variantId) return;

      var variants = window.productVariants[productId];
      if (!variants || !variants.length) return;

      var variant = null;
      for (var v = 0; v < variants.length; v++) {
        if (parseInt(variants[v].id, 10) === variantId) { variant = variants[v]; break; }
      }
      if (!variant) return;

      /* Only push when the BUY BOX changed. If the shopper has deliberately
         set a different size on the bundle card itself, leave it be - we must
         not trade one silent override for another. */
      if (variantId === lastPushed) return;
      lastPushed = variantId;

      var card = bundle.querySelector('[data-bundle-product-item-id="' + productId + '"]');
      if (!card) return;

      var options = [variant.option1, variant.option2, variant.option3];

      for (var i = 0; i < options.length; i++) {
        var value = options[i];
        if (value === null || value === undefined || value === '') continue;

        var fieldset = card.querySelector('.swatch[data-option-idx="' + i + '"]');
        if (!fieldset) continue;

        var element = fieldset.querySelector('.swatch-element[data-value="' + value + '"]');
        var input = element && element.querySelector('input');
        if (!input || input.disabled || input.checked) continue;

        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } catch (err) {
      /* Presentation nicety - never let it break the page. */
    }
  }

  function queueSync(event) {
    /* Ignore anything the bundle fired itself, or the two would fight. */
    if (event && event.target && event.target.closest &&
        event.target.closest('product-bundle')) return;
    clearTimeout(timer);
    timer = setTimeout(syncBundleToBuyBox, SYNC_DELAY);
  }

  document.addEventListener('change', queueSync, true);
  document.addEventListener('click', queueSync, true);

  /* Also on load, so a ?variant= link lands the bundle on the right size. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(syncBundleToBuyBox, 600);
    });
  } else {
    setTimeout(syncBundleToBuyBox, 600);
  }
})();

/* -----------------------------------------------------------------------------
   Match the Crew - the companion pair starts with NO size selected.
   Added 12 September 2026.

   WHY
   The block above keeps the card for THIS product in step with the buy box, so
   that card can no longer be wrong. The companion product has no source of
   truth: it sat on its first variant (men's S) and could be added to the cart
   at a size the shopper never chose. Nothing should reach the cart at a size
   nobody picked.

   WHAT IT DOES
   Clears the companion card's size on load, says so beneath the TOTAL, and
   refuses the submit until a size is chosen. The submit guard also blocks a
   card whose group_id is not a variant id, so an item can never be dropped
   from the cart silently - product-bundle.js skips a blank group_id without
   telling anyone, which would also lose the bundle discount.

   IMPLEMENTATION NOTES
   1. The theme's own <select name="group_id"> is deliberately left populated.
      updateBundleTotalPrice() reads its selected option and throws if there
      isn't one, which breaks the TOTAL. The checked radio is our source of
      truth for "has a size been chosen"; the theme sets the select correctly
      the moment one is picked.
   2. The single-value Colour option is left checked on purpose. Both
      changeSwatch() and updateVariants() call
      .find(radio => radio.checked).value on every option group and throw on
      an empty one.
   3. For the same reason we open the CHOOSE SIZE panel ourselves while no size
      is set - the theme's toggle calls updateVariants() and would throw. Once
      a size is chosen the theme's own handlers take over again.
   4. Sold-out sizes on a cleared card are marked here, because the theme only
      marks them inside those two functions.
   ----------------------------------------------------------------------------- */
(function () {
  var PLACEHOLDER = 'Please select';
  var ATTR = 'data-tt-size-required';
  var URGENT = 'data-tt-size-urgent';

  function sizeGroup(card) {
    var groups = card.querySelectorAll('.swatch');
    for (var i = 0; i < groups.length; i++) {
      var label = groups[i].querySelector('.swatch-label');
      if (!label || !/size/i.test(label.textContent)) continue;
      if (groups[i].querySelectorAll('.swatch-element').length > 1) return groups[i];
    }
    return null;
  }

  function hasSize(card) {
    var group = sizeGroup(card);
    if (!group) return true;
    return !!group.querySelector('input:checked');
  }

  function needsSize(card) {
    if (card.getAttribute(ATTR) === '1' && !hasSize(card)) return true;
    var select = card.querySelector('[name=group_id]');
    var value = select ? String(select.value || '').trim() : '';
    return !/^[0-9]+$/.test(value);
  }

  function mainProductId() {
    var button = document.getElementById('product-add-to-cart');
    var form = button && button.closest('form');
    var input = form && form.querySelector('[name="product-id"]');
    return input ? input.value : null;
  }

  /* "Men's Hybrid Boardshorts - Dreamwave" -> "Men's" */
  function shortLabel(card) {
    var title = card.querySelector('.product-title');
    var text = title ? title.textContent.trim() : '';
    var lead = text.split(/hybrid/i)[0].replace(/[-,\s]+$/, '').trim();
    return lead || 'second';
  }

  function markAvailability(card, group) {
    var variants = window.productVariants &&
      window.productVariants[card.getAttribute('data-bundle-product-item-id')];
    if (!variants) return;
    var elements = group.querySelectorAll('.swatch-element');
    for (var e = 0; e < elements.length; e++) {
      var value = elements[e].getAttribute('data-value');
      var available = false;
      for (var v = 0; v < variants.length; v++) {
        var variant = variants[v];
        if (!variant.available) continue;
        if (variant.option1 === value || variant.option2 === value || variant.option3 === value) {
          available = true;
          break;
        }
      }
      var input = elements[e].querySelector('input');
      if (available) {
        elements[e].classList.remove('soldout');
        if (input) input.removeAttribute('disabled');
      } else {
        elements[e].classList.add('soldout');
        if (input) input.setAttribute('disabled', 'disabled');
      }
    }
  }

  function clearCompanionSizes(bundle) {
    var mainId = mainProductId();
    var cards = bundle.querySelectorAll('.bundle-product-item');
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      if (card.getAttribute(ATTR) === '1') continue;
      if (mainId && card.getAttribute('data-bundle-product-item-id') === mainId) continue;
      var group = sizeGroup(card);
      if (!group) continue;
      var inputs = group.querySelectorAll('input');
      for (var i = 0; i < inputs.length; i++) inputs[i].checked = false;
      var header = group.querySelector('[data-header-option]');
      if (header) header.textContent = PLACEHOLDER;
      markAvailability(card, group);
      card.setAttribute(ATTR, '1');
    }
  }

  function missingCards(bundle) {
    var out = [];
    var cards = bundle.querySelectorAll('.bundle-product-item.isChecked');
    for (var i = 0; i < cards.length; i++) {
      if (needsSize(cards[i])) out.push(cards[i]);
    }
    return out;
  }

  function noticeFor(bundle) {
    var notice = bundle.querySelector('.tt-bundle-size-notice');
    if (notice) return notice;
    var action = bundle.querySelector('.bundle-product-action');
    if (!action) return null;
    notice = document.createElement('p');
    notice.className = 'tt-bundle-size-notice';
    notice.setAttribute('role', 'status');
    notice.style.cssText = 'margin:10px 0 0;font-size:13px;line-height:1.4;text-align:center;';
    action.parentNode.insertBefore(notice, action);
    return notice;
  }

  function refresh(bundle) {
    var missing = missingCards(bundle);
    var notice = noticeFor(bundle);
    if (!missing.length) bundle.removeAttribute(URGENT);
    if (!notice) return missing;
    if (!missing.length) {
      notice.textContent = '';
      notice.style.display = 'none';
      return missing;
    }
    var urgent = bundle.getAttribute(URGENT) === '1';
    var names = [];
    for (var i = 0; i < missing.length; i++) names.push(shortLabel(missing[i]) + ' pair');
    notice.textContent = 'Choose a size for the ' + names.join(' and the ') + '.';
    notice.style.display = '';
    /* Dark enough to read as an instruction rather than more fine print. */
    notice.style.color = urgent ? '#c0392b' : '#1f1f1f';
    notice.style.fontWeight = urgent ? '700' : '500';
    return missing;
  }

  function openCard(card) {
    var bundle = card.closest('product-bundle');
    if (!bundle) return;
    var items = bundle.querySelectorAll('.bundle-product-item');
    var wasOpen = card.classList.contains('is-open');
    for (var i = 0; i < items.length; i++) items[i].classList.remove('is-open');
    if (!wasOpen) card.classList.add('is-open');
  }

  /* Capture phase on document runs before the form's own bubble-phase submit
     listener, so stopPropagation() here keeps the theme's add-to-cart from
     firing at all, while leaving our other document listeners alone. */
  document.addEventListener('submit', function (event) {
    try {
      var form = event.target;
      if (!form || !form.closest) return;
      var bundle = form.closest('product-bundle');
      if (!bundle) return;
      var missing = missingCards(bundle);
      if (!missing.length) return;
      event.preventDefault();
      event.stopPropagation();
      bundle.setAttribute(URGENT, '1');
      refresh(bundle);
      if (!missing[0].classList.contains('is-open')) openCard(missing[0]);
    } catch (err) {
      /* Never let the guard itself block a valid add. */
    }
  }, true);

  document.addEventListener('click', function (event) {
    try {
      if (!event.target || !event.target.closest) return;
      var toggle = event.target.closest('.bundle-product-toogle');
      if (!toggle) return;
      var card = toggle.closest('.bundle-product-item');
      if (!card || !needsSize(card)) return;
      event.preventDefault();
      event.stopPropagation();
      openCard(card);
    } catch (err) {
      /* Fall through to the theme's own toggle. */
    }
  }, true);

  function queueRefresh(event) {
    if (!event.target || !event.target.closest) return;
    var bundle = event.target.closest('product-bundle');
    if (!bundle) return;
    setTimeout(function () { refresh(bundle); }, 0);
  }

  document.addEventListener('change', queueRefresh, true);
  document.addEventListener('click', queueRefresh, true);

  /* The bundle is a custom element, so wait for it to upgrade. */
  var tries = 0;
  function init() {
    tries++;
    var bundle = document.querySelector('product-bundle');
    if (bundle && bundle.querySelector('.swatch')) {
      clearCompanionSizes(bundle);
      refresh(bundle);
      return;
    }
    if (tries < 25) setTimeout(init, 300);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 400); });
  } else {
    setTimeout(init, 400);
  }
})();
